<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="2 3 25 25"
    stroke-width="2"
    stroke="currentColor"
    class="text-blue-500"
    v-tooltip="tooltip"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
    v-on="$listeners"
    outline = none;
  >
    <rect x="9" y="9" width="14" height="14" rx="2"></rect>
    <path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"></path>
  </svg>
</template>

<script>

export default {
  props: {
    tooltip: {
      type: String,
      default: 'Copy'
    }
  }
}
</script>
